import { useEffect, useState } from "react";
import WalletSettingsPopup from "../WalletSettingsPopup";
import {ReactComponent as SettingsIcon} from "../../../assets/icons/settings.svg";
import { Wallets } from "helpers/WalletList";
import DropdownIcon from "assets/icons/dropdown.svg";
import "./style.scss";
import { useSelector } from "react-redux";
import state from "redux/state";

const WalletSettings = ({}) => {
  const state = useSelector((state) => state.storage);
  const [settingsPopup, setSettingsPopup] = useState(false);

  const [providerIconUrl, setProviderIconUrl] = useState();

  useEffect(() => {
    // Sets Connected Wallet Icon
    let provider = localStorage.getItem("provider");
    for(let i =0; i < Wallets.length; i++) {
      if(provider === Wallets[i].provider) {
        setProviderIconUrl(Wallets[i].icon);
        break;
      }
    }
  }, [state.walletConnected]);

  return <>
    <div className="walletSettings" onClick={() => setSettingsPopup(true)}>
      <img src={providerIconUrl} width={16} height={16} alt="Wallet"/>
      <p className="walletAddress">
        {
          state.publicKey.toBase58().slice(0,6) + " ···· " + state.publicKey.toBase58().slice(-3)
        }
      </p>
      <img src={DropdownIcon}/>
    </div>

    { settingsPopup &&
      <WalletSettingsPopup open={settingsPopup} onClose={() => setSettingsPopup(false)}/>
    }
  </>
}
export default WalletSettings;